import { render, staticRenderFns } from "./ViewLiveLink.vue?vue&type=template&id=47f82282&scoped=true"
import script from "./ViewLiveLink.vue?vue&type=script&lang=js"
export * from "./ViewLiveLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f82282",
  null
  
)

export default component.exports